export const submissionMethodOptions = [
  { label: 'Online Portal', value: 'online_portal' },
  { label: 'Mail', value: 'mail' },
  { label: 'Fax', value: 'fax' },
  { label: 'Email', value: 'email' },
  { label: 'Email to Customer Only', value: 'email_to_customer_only' },
];

export const statusOptions = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

export const waterAuthorityFormFields = [
  {
    name: 'name',
    kind: 'text',
  },
  {
    name: 'contact_email',
    kind: 'text',
  },
  {
    name: 'online_portal_url',
    kind: 'text',
  },
  {
    name: 'mailing_address',
    kind: 'text',
  },
  {
    name: 'fax_number',
    kind: 'text',
  },
  {
    name: 'submission_method',
    kind: 'select',
    choices: submissionMethodOptions,
  },
  {
    name: 'status',
    kind: 'select',
    choices: statusOptions,
  },
  {
    name: 'requires_account_number',
    kind: 'toggle',
    onLabel: 'Yes',
    offLabel: 'No',
    xs: 4,
  },
  {
    name: 'requires_service_number',
    kind: 'toggle',
    onLabel: 'Yes',
    offLabel: 'No',
    xs: 4,
  },
  {
    name: 'requires_backflow_device_account_number',
    kind: 'toggle',
    onLabel: 'Yes',
    offLabel: 'No',
    xs: 4,
  },
];
